import React from "react";
import "./HeroSection.css";

function HeroSection() {
  return (
    <div className="hero">
      <div className="hero-frame">
        <h1 className="hero-name">
          <span className="first">Christi</span>{" "}
          <span className="middle">A</span>{" "}
          <span className="last">Harlow</span>
        </h1>
      </div>
    </div>
  );
}

export default HeroSection;

